export enum ArticleStatus {
	Draft,
	InApproval,
	Approved,
}

export enum PollStatus {
	Draft,
	InApproval,
	Approved,
	Archived,
}

export enum MenuItemStatus {
	Active,
	Expired,
}

export enum ICOOrderStatus {
	Pending,
	Paid,
	Rejected,
	Partial,
	Cancelled,
	PendingDelivery,
	Delivered,
}

export enum ShopStatus {
	Draft,
	InApproval,
	Approved,
}

// order header status
export enum OrderStatus {
	/// <summary>
	/// Order is a draft and will be removed from system on schedule if doesn't pass to Pending or higher status
	/// </summary>
	Draft,
	/// <summary>
	/// payment was successful, order was placed, shop hasn’t accepted it yet.
	/// </summary>
	Pending,
	/// <summary>
	/// by user, during the pending phase. - not visibile to shop
	/// </summary>
	Canceled,
	/// <summary>
	/// by shop, before accepting the order.
	/// </summary>
	Rejected,
	/// <summary>
	/// when shop has accepted the order.
	/// </summary>
	Processing,
	/// <summary>
	/// when shop has partially shipped the order.
	/// </summary>
	PartiallyShipped,
	/// <summary>
	/// when shop has shipped the order.
	/// </summary>
	Shipped,
}

export enum OrderPaymentStatus {
	/// <summary>
	/// Payment at salon
	/// </summary>
	WaitingForPayment,
	/// <summary>
	/// Payment rejected
	/// </summary>
	Rejected,
	/// <summary>
	/// Online payment
	/// </summary>
	Verified,
}

export enum ShippingStatus {
	/// <summary>
	///
	/// </summary>
	NotYetShipped,
	/// <summary>
	/// Once products are shipped
	/// </summary>
	Shipped,
}

export enum JobStatus {
	/// <summary>
	/// Draft
	/// </summary>
	Draft,
	/// <summary>
	/// InApproval. Meant for admin to publish it on board (not used for now)
	/// </summary>
	InApproval,
	/// <summary>
	/// Approved. Meant when job is approved by Admin to be published on board (not used for now job is automatically in status Approved)
	/// </summary>
	Approved,
	/// <summary>
	/// InProgress. Job is assigned when job owner Approves = selects a job application from another user.
	/// Job can not be edited or removed and all other job applications can not be selected anymore.
	/// </summary>
	Assigned,
	/// <summary>
	///
	/// </summary>
	Closed,
}

export enum WorkStatus {
	/// <summary>
	/// Draft
	/// </summary>
	Draft,
	/// <summary>
	/// When work is done
	/// </summary>
	Done,
	/// <summary>
	/// Approved. When work is approved by job owner
	/// </summary>
	Approved,
	/// <summary>
	/// When job owner rejects a job
	/// </summary>
	Rejected,
}
